export default "__VITE_ASSET__CuhK5avy__"